import {uploadFileToBlob} from '../api/POCCMSPortalAPI/services/blobCalls';
import {
  getContentByMiniToolId,
  getMiniPOCToolById,
} from '../api/POCWebPortalAPI/POCToolsCalls';
import {isFile} from './validators';

export const uploadImage = async (image, navigate) => {
  if (!image?.url) {
    try {
      return await uploadFileToBlob(image.file, image.fileName);
    } catch (err) {
      if (err === 401) {
        return navigate('/Login');
      }
    }
  } else {
    return image.url;
  }
};

export const autoloadFiles = async (
  isThereError,
  displayPocToolContent,
  navigate,
) => {
  return await displayPocToolContent.map(async item => {
    if (item.type === 'img' && isFile(item.value)) {
      try {
        const link = await uploadFileToBlob(item.value, item.fileName);
        return {...item, value: link};
      } catch (err) {
        isThereError = true;
        if (err === 401) {
          navigate('/Login');
          throw err;
        }
      }
    }
    if (item.type === 'pdf' && isFile(item.value)) {
      try {
        const link = await uploadFileToBlob(item.value, item.fileName);
        return {...item, value: link};
      } catch (err) {
        if (err === 401) {
          navigate('/Login');
          throw err;
        }
        alert(err);
        isThereError = true;
      }
    }
    return item;
  });
};

export const loadMiniToolsContent = async POCToolId => {
  const POCTool = await getMiniPOCToolById(POCToolId);

  const minitoolsWithConent = POCTool.miniTools.map(async minitool => {
    const minitoolContent = await getContentByMiniToolId(
      POCToolId,
      minitool.id,
    );

    return {...minitool, categories: minitoolContent};
  });
  return await Promise.all(minitoolsWithConent);
};
